module.exports = __webpack_public_path__ + "static/media/icon-edit.5b536bfa.svg";